module.exports = __webpack_public_path__ + "media/packs/images/partners/tabletocki-logo-0b353fb604a3be104a68f42cd2c17158.jpg";